import axios from "axios";
import { getToken } from "../../Utils/UpdateUsersState";

const createUser = async (
  username,
  email,
  role,
  key,
  address,
  password,
  parent_company
) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}admin-panel/user/`,
      {
        name: username,
        email,
        role,
        api_key: key,
        // company_name:company_name,
        address: address,
        password: password,
        parent_company: parent_company || null,
      },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return res;
  } catch (e) {
    console.log("error", e);
    throw e;
  }
};

const editUser = async (id, username, email, role, key, parent_company) => {
  try {
    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}admin-panel/user/`,
      {
        user_id: id,
        name: username,
        email,
        role,
        api_key: key,
        parent_company: parent_company || null,
      },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    throw e;
  }
};

const getUsersList = async (include_all = false) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin-panel/user/`,
      {
        params: {
          include_all: include_all ?? false,
        },
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );

    const updatedData = res?.data?.map(user => ({
      ...user,
      profile_picture: user.profile_picture
        ? `${process.env.REACT_APP_MEDIA_URL}${user.profile_picture}`
        : null
    }));

    return { ...res, data: updatedData };

  } catch (e) {
    console.log(e, "error");
    return e;
  }
};

const alterUserStatus = async (id, act) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}admin-panel/user-status/`,
      {
        user_id: id,
        action: act,
      },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    return e;
  }
};

const loginAsUser = async (id) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}admin-panel/login-as-user/`,
      {
        user_id: id,
      },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    const updatedProfilePicture = res?.data?.profile_picture
      ? `${process.env.REACT_APP_MEDIA_URL}${res?.data?.profile_picture}`
      : null;
    const data = { ...res.data, profile_picture: updatedProfilePicture };
    return {...res, data: data}
  } catch (e) {
    console.log(e, "error");
    return e;
  }
};

const pageAccess = async (id, pageName, act) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}admin-panel/page-access/`,
      {
        user_id: id,
        page_name: pageName,
        action: act,
      },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    return e;
  }
};

const passwordReset = async (id, password) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}admin-panel/password-reset/`,
      { user_id: id, new_password: password },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    return e;
  }
};

const searchUser = async (q) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin-panel/search/`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
        params: { q },
      }
    );
    const updatedData = res?.data?.map(user => ({
      ...user,
      profile_picture: user.profile_picture
        ? `${process.env.REACT_APP_MEDIA_URL}${user.profile_picture}`
        : null
    }));

    return { ...res, data: updatedData };
  } catch (e) {
    console.log(e, "error");
    return e;
  }
};

const getCompanyList = async () => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin-panel/company/`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    const updatedData = res?.data?.map(user => ({
      ...user,
      profile_picture: user.profile_picture
        ? `${process.env.REACT_APP_MEDIA_URL}${user.profile_picture}`
        : null
    }));

    return { ...res, data: updatedData };
  } catch (e) {
    console.log(e, "error");
    return e;
  }
};

const bulkAssignParentCompany = async (parentCompanyId, userIds) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}admin-panel/assign-parent-company/`,
      {
        parent_company_id: parentCompanyId,
        user_ids: userIds,
      },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    return e;
  }
};

const deleteUser = async (id) => {
  try {
    const res = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}admin-panel/user/delete/?user_id=${id}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    return e;
  }
};

export {
  createUser,
  getUsersList,
  alterUserStatus,
  loginAsUser,
  pageAccess,
  editUser,
  searchUser,
  passwordReset,
  getCompanyList,
  bulkAssignParentCompany,
  deleteUser,
};
